import { render, staticRenderFns } from "./ServiceInfo.vue?vue&type=template&id=571f6fb2&scoped=true"
import script from "./ServiceInfo.vue?vue&type=script&lang=ts"
export * from "./ServiceInfo.vue?vue&type=script&lang=ts"
import style0 from "./ServiceInfo.vue?vue&type=style&index=0&id=571f6fb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "571f6fb2",
  null
  
)

export default component.exports